import { DeviceType, SEARCH_COLUMN, TYPE_PRODUCT } from '@/constant';
import { useAppSelector, useAppSWRInfinity, useLastElement } from '@/hooks';
import { DefaultLayout } from '@/layouts';
import { IProductItem, IQueryParamsCommon } from '@/models';
import PreviewProductModules from '@/modules/preview-product';
import PreviewProductMobileModules from '@/modules/preview-product/mobile';
import { commonSelectors, deviceTypeSelector } from '@/store/reducers/commonSlice';
import { InferGetServerSidePropsType } from 'next';
import { useRouter } from 'next/router';
import { ReactElement } from 'react';
import { getServerSideProps } from '..';
import { getKeyQueryString, removeEmptyObject } from '@/modules/preview-product/utils';
import { OPTIONS_FILTER_DESC } from '@/modules/preview-product/constants';

const PreviewProduct = ({ deviceType }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
	const { query, push } = useRouter();
	const { dataCategoryTree, dataBrand, dataCategory } = useAppSelector(commonSelectors);
	const deviceTypeCheck = useAppSelector(deviceTypeSelector);
	const isMobile = (deviceTypeCheck ?? deviceType) === DeviceType.MOBILE;
	const categoryList = dataCategory.data?.data.rows ?? [];
	// const categoryList =
	// 	query['ParentId'] !== null && (query['ParentId'] as string)?.length > 0
	// 		? dataCategory.data?.data.rows.filter((item: any) => {
	// 				return item.level === Number(query['ParentId']);
	// 		  })
	// 		: [];

	// const subCategoryList =
	// 	query['subChildCategory'] !== null && (query['subChildCategory'] as string)?.length > 0
	// 		? dataCategory.data?.data.rows.filter((item: any) => {
	// 				return item.level === Number(query['subChildCategory']);
	// 		  })
	// 		: [];

	const {
		data: productFilter,
		size,
		setSize,
		response,
		isValidating,
	} = useAppSWRInfinity<IProductItem[]>(
		{
			request: {
				url: `/products${
					query?.typeProduct === TYPE_PRODUCT.NEW
						? '/New'
						: query?.typeProduct === TYPE_PRODUCT.DISCOUNT
						? '/Discount'
						: query?.typeProduct === TYPE_PRODUCT.POPULAR
						? '/Popularity'
						: ''
				}?${getKeyQueryString(query)}`,
				// url: `/products${
				// 	query?.typeProduct === TYPE_PRODUCT.NEW
				// 		? '/New'
				// 		: query?.typeProduct === TYPE_PRODUCT.DISCOUNT
				// 		? '/Discount'
				// 		: query?.typeProduct === TYPE_PRODUCT.POPULAR
				// 		? '/Popularity'
				// 		: ''
				// }?${getKeyQueryString(query)}`,
				method: 'GET',
			},
		},
		{ revalidateFirstPage: false },
	);

	const { lastElementRef } = useLastElement(
		isValidating,
		response?.data?.pagination?.totalPage! >= size + 1,
		// response?.pagination?.totalPage! >= size + 1,
		() => {
			// setSize(size);
			setSize(size + 1);
		},
	);

	const handlePushQuery = (newQuery: Partial<IQueryParamsCommon>, option?: { reload: boolean }) => {
		const obj = { ...query, ...newQuery };

		const convertObj = removeEmptyObject(obj);

		option?.reload
			? push(`/preview-product`, `/san-pham`)
			: push(
					`/preview-product?${getKeyQueryString(convertObj)}`,
					`/san-pham?${getKeyQueryString(convertObj)}`,
					{
						shallow: true,
					},
			  );
	};

	// console.log('sadf level PAGE', categoryList);

	return !isMobile ? (
		<PreviewProductModules
			productFilter={productFilter}
			dataBrand={dataBrand}
			isValidating={isValidating}
			onPushQuery={handlePushQuery}
			currentQuery={query}
			dataCategoryTree={dataCategoryTree}
			categoryList={categoryList}
			optionsSort={OPTIONS_FILTER_DESC}
			ref={lastElementRef}
			size={size}
		/>
	) : (
		<PreviewProductMobileModules
			categoryList={categoryList}
			productFilter={productFilter}
			isValidating={isValidating}
			onPushQuery={handlePushQuery}
			currentQuery={query}
			dataBrand={dataBrand}
			dataCategoryTree={dataCategoryTree}
			optionsSort={OPTIONS_FILTER_DESC}
			ref={lastElementRef}
			size={size}
		/>
	);

	// return <div>ehllo</div>;
};

export default PreviewProduct;

PreviewProduct.getLayout = (page: ReactElement) => (
	<DefaultLayout
		seoProps={{ title: 'Sản phẩm | Nga Liem', openGraph: { title: 'Sản phẩm | Nga Liem' } }}
		forceTitleRender
	>
		{page}
	</DefaultLayout>
);
